export default __webpack_public_path__ + "static/media/users.a57f68fe.svg";